/* istanbul ignore file */
import { connect } from 'react-redux'
import withLoader from 'commons/js/components/withLoader'

import { BottomBarPlaceholder } from '../../ui/BottomBar'
import BottomBar from './BottomBar'
import { bookingDataSelector } from 'rental-car-contract/js/selectors/booking'

function mapStateToProps (state, props) {
    return {
        booking: bookingDataSelector(state),
        isLoading: props.disabled,
    }
}

export default connect(mapStateToProps, null)(withLoader(BottomBarPlaceholder)(BottomBar))
